import { action, observable } from "mobx";
import UiMeet3dEventStore from "./UiMeet3dEventStore";

class UiMeet3dEventPageStore {
  @observable isUiMeet3dEventModalOpen = false;

  @observable uiMeet3dEvent = null;

  @observable isLoading = false;

  uiMeet3dEventStore = null;

  constructor(isLeadEventsPage = false) {
    this.uiMeet3dEventStore = new UiMeet3dEventStore();
    this.uiMeet3dEventStore.isLoading = true;
    if (isLeadEventsPage) {
      this.uiMeet3dEventStore.searchParams.type = ["1"];
    } else {
      this.uiMeet3dEventStore.searchParams.type = ["0", "2"];
    }
  }

  @action
  openDetails(uiMeet3dEvent) {
    this.isUiMeet3dEventModalOpen = true;
    this.uiMeet3dEventStore.uiMeet3dEvent = null;

    this.loadDetails(uiMeet3dEvent);
  }

  @action
  loadDetails(uiMeet3dEvent) {
    this.isLoading = true;
    this.uiMeet3dEventStore.uiMeet3dEventId = uiMeet3dEvent.uiMeet3dEventId;

    return this.uiMeet3dEventStore.getOne().finally(() => {
      this.isLoading = false;
    });
  }

  @action
  closeDetails() {
    this.isUiMeet3dEventModalOpen = false;
  }
}

export default UiMeet3dEventPageStore;
